export interface DeflexMeasurements {
  A?: number;
  B?: number;
}
